export const M_NUMBER_REGEX = /[Mm]\d+/;
export const ORDER_TYPES = ['priceHufAsc', 'priceHufDesc', 'createDateTimeDesc', 'createDateTimeAsc'];
